import { enUS, zhTW, zhCN, ko, ja, th, vi, id, ms } from 'date-fns/locale';
import i18n from '../i18n';

const localeMap: Record<string, Locale> = {
    'en': enUS,
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'ko': ko,
    'ja': ja,
    'th': th,
    'vi': vi,
    'id': id,
    'ms': ms,
};

export const getDateFnsLocale = (): Locale => {
    const currentLang = i18n.language || 'en';
    return localeMap[currentLang] || enUS;
};
